// removed by extract-text-webpack-plugin
module.exports = {"fh5coperson":"src-components-Section----User-module---fh5coperson---3sDKZ","fh5coname":"src-components-Section----User-module---fh5coname---2k0R7","fh5codesignation":"src-components-Section----User-module---fh5codesignation---QIWYX","fh5cobio":"src-components-Section----User-module---fh5cobio---Q9nau"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/User.module.scss
// module id = 81
// module chunks = 144251824217401 183328146348521 186063380969677